import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-crisis-card',
  templateUrl: './crisis-card.component.html',
  styleUrls: ['./crisis-card.component.scss']
})
export class CrisisCardComponent implements OnInit, OnDestroy {

	@Input() icon: string = '';
	@Input() head: string = '';
	@Input() body: string = '';
	@Input() link: string = '';
	@Input() headTranslateId: string = '';
	@Input() bodyTranslateId: string = '';

	public displayHead: string = '';
	public displayBody: string = '';
	private destroy$ = new Subject<void>();

	constructor(private translationService: TranslationService) {}

	ngOnInit(): void {
		this.displayHead = this.head;
		this.displayBody = this.body;

		// Listen for language changes
		this.translationService.currentLanguage$.pipe(
			takeUntil(this.destroy$)
		).subscribe(() => {
			// Reset to original values when language changes
			// Parent component will trigger translation
			this.displayHead = this.head;
			this.displayBody = this.body;
		});
	}	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	/**
	 * Apply translated text for head
	 */
	public applyHeadTranslation(translatedText: string): void {
		if (translatedText) {
			this.displayHead = translatedText;
		}
	}

	/**
	 * Apply translated text for body
	 */
	public applyBodyTranslation(translatedText: string): void {
		if (translatedText) {
			this.displayBody = translatedText;
		}
	}
}
